import { ModelType } from './types/item-response.js';
export const supportedModels = ModelType.options;
export const parseModelName = (model) => ModelType.parse(model);
export const isSupportedModel = (model) => {
    try {
        parseModelName(model);
        return true;
    }
    catch {
        return false;
    }
};
